


















import Vue from 'vue'
import Component from 'vue-class-component'
@Component
export default class IconBase extends Vue {
  // TODO 指定ができないため要修正
  iconName = {
    type: String,
    default: 'box'
  };
  width = {
    type: [Number, String],
    default: 18
  };
  height = {
    type: [Number, String],
    default: 18
  }
  iconColor = {
    type: String,
    default: 'currentColor'
  }
}
